var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkin_information_btoom"},[_c('div',{staticClass:"checkin_information_data"},[_c('query-info',{on:{"query":_vm.handleQuery}}),_c('dept-statistics',{ref:"deptStatisticsRef"})],1),_c('application-leave-absence')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }